export default __webpack_public_path__ + "static/media/Download.b6a6066b.svg";